import type { SessionExpiredState } from './types';

export const initialState: SessionExpiredState = {
    isSessionExpired: false
};
